import { useEffect } from 'react';

interface JsonLdProps {
  data: Record<string, unknown>;
}

export function JsonLd({ data }: JsonLdProps) {
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(data);
    script.id = 'jsonld-script';
    
    // 既存のJSON-LDスクリプトを削除
    const existingScript = document.getElementById('jsonld-script');
    if (existingScript) {
      existingScript.remove();
    }
    
    document.head.appendChild(script);
    
    return () => {
      const scriptToRemove = document.getElementById('jsonld-script');
      if (scriptToRemove) {
        scriptToRemove.remove();
      }
    };
  }, [data]);
  
  return null;
}

export default JsonLd;